
import Vue from 'vue';
import PageNotificationBar from '~/components/page-components/PageNotificationBar.vue'


export default Vue.extend({
  name: 'BrowserExtensionBanner',
  components: {PageNotificationBar},
  data() {
    return {
      showExtensionMessage: ! this.$cookies.isKey('bah-extension-modal'),
    }
  },
  methods: {
    close(): void {
      this.showExtensionMessage = false;
      this.$cookies.set('bah-extension-modal', 'skip', '14d')
    },
  },
  computed: {
    show(): boolean {
      const kip_ext_is_installed = this.$cookies.get('kip-extension-is-installed');

      return (kip_ext_is_installed === undefined || kip_ext_is_installed === null)
        && this.showExtensionMessage;
    }
  }
})
